import { useEffect, useContext, useState, useRef } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import store from "../../stores/store";
import { useSelector } from "react-redux";
import {
  addLayer,
  fetch,
  fetchLayersRequest,
  key,
  layerResponseFormatter,
  trans,
  updateLayerPropertiesFromConfig,
} from "../../lib/utils";
import Loader from "../loader/loader";
import "react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css";
import filterFactory, { textFilter } from "react-bootstrap-table2-filter";
import { getLayerById } from "../map/mapUtils";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import LayerPreviewComponent from "./layerPreviewComponent";

function CSWPreviewComponent(props) {
  const [source, setSource] = useState(null);
  const [availableObjects, setAvailableObjects] = useState(null);
  const [content, setContent] = useState(null);

  const sources = useSelector((state) => store.getState().sources);
  const layers = useSelector((state) => store.getState().layers);

  const registeredLayerTree = useSelector(
    (state) => store.getState().registeredLayerTree.tree
  );

  useEffect(() => {
    if (props.source) {
      setSource(sources[props.source.id]);
    }

    if (source && !availableObjects) {
      fetchCSWResults();
    }
  }, [source, layers]);

  function fetchCSWResults() {
    let url =
      "metadataSearch.php?profile=1&search_request_method=advance&metadata_servers=[".concat(
        source.url,
        "]&title=&abstract=&resourceidentifier=&type=&keyword=&topiccategory=&from=&to=&calendartype=&organisationname=&responsiblepartyrole=&conditionapplyingtoaccessanduse=&accessconstraints=&lineage=&specificationtitle=&denominator=&distancevalue=&distanceuom=&degree=&bbox=-111.82835935602577,30.61838676243835,160.80835935602096,45.351640553314574&tight=false"
      );
    fetch(window["appConfig"]()["api"](url), "GET", {}, null, (resp) => {
      setAvailableObjects([...resp.data.rows]);
    });
  }

  return content ? (
    content
  ) : source ? (
    <PerfectScrollbar style={{ height: "calc(100vh - 25rem)" }}>
      <div className="mt-3 m-2">
        <h4 className="mt-2">{trans("Service information")}</h4>
        <div className="mb-3">
          <label className="color-get-blue strong ">
            {trans("Service Name")}
          </label>
          <div className="mt-2">{source.title}</div>
          <div className="mt-1">
            <span className="text-secondary">{source.url}</span>
          </div>
        </div>
        <div className="mb-3">
          <label className="color-get-blue strong ">
            {trans("Service Type")}
          </label>
          <div className="mt-2">{source.type}</div>
        </div>
        <div className="mb-3">
          <label className="color-get-blue strong ">
            {trans("Results")}
            {availableObjects ? " (".concat(availableObjects.length, ")") : ""}
          </label>
          <div className="mt-2">
            {availableObjects ? (
              <BootstrapTable
                keyField="fileIdentifier"
                key={key()}
                data={availableObjects}
                expandRow={{
                  renderer: (row) => {
                    return row.abstract;
                  },
                  showExpandColumn: true,
                  onlyOneExpanding: true,
                  expandColumnRenderer: ({ expanded, rowKey, expandable }) => {
                    return !expanded ? (
                      <i className="fas fa-plus"></i>
                    ) : (
                      <i className="fas fa-minus"></i>
                    );
                  },
                }}
                columns={[
                  {
                    dataField: "fileIdentifier",
                    text: "",
                    hidden: true,
                  },
                  {
                    dataField: "legend",
                    headerStyle: (colum, colIndex) => {
                      return { width: "50px", textAlign: "center" };
                    },
                    formatter: function (cell, row) {
                      return (
                        <div className="text-center">
                          <img
                            src={window["appConfig"]()
                              ["path"]()
                              .concat("assets/images/", row.icon)}
                            height="16"
                          ></img>
                        </div>
                      );
                    },
                  },
                  {
                    dataField: "metadataInfo",
                    headerStyle: (colum, colIndex) => {
                      return { width: "22px", textAlign: "center" };
                    },
                    formatter: function (cell, row) {
                      let url = window["appConfig"]()["api"](
                        "metadataGetRecordsById.php?lang=el_gr&recordId=".concat(
                          row.fileIdentifier,
                          "&serviceUrl=",
                          row.serverUrl
                        )
                      );

                      return (
                        <div
                          className="text-center"
                          role="button"
                          onClick={() => {
                            window["secondaryModal"].setState({
                              title: "",
                              size: "xl",
                              height: "calc(100vh - 210px)",
                              show: true,
                              title: row.title,
                              body: (
                                <iframe
                                  src={url}
                                  width={"100%"}
                                  height={"99%"}
                                ></iframe>
                              ),
                              footer: [
                                <button
                                  className="btn btn-sm btn-link border"
                                  onClick={() => {
                                    window["secondaryModal"].setState({
                                      show: false,
                                    });
                                  }}
                                >
                                  {trans("Close")}
                                </button>,
                              ],
                            });
                          }}
                        >
                          <i className="fas fa-info-circle "></i>
                        </div>
                      );
                    },
                  },
                  {
                    dataField: "title",
                    type: "text",
                    text: trans("Title"),
                    filter: textFilter(),
                    sort: true,

                    formatter: function (cell, row) {
                      return (
                        <span role="button" className="text-break">
                          {row.title}
                        </span>
                      );
                    },
                  },
                ]}
                wrapperClasses="bg-white"
                striped
                hover
                filter={filterFactory()}
              />
            ) : (
              <Loader></Loader>
            )}
          </div>
        </div>
      </div>
    </PerfectScrollbar>
  ) : null;
}
export default CSWPreviewComponent;
